// privacyPolicyData.js

const privacyPolicyData = {
  title: "Privacy Policy",
  lastUpdate: "Last Update: 13/10/2023",
  intro: `
    HotelPoint is a web platform / software, which is an all-in-one cloud solution for managing
    properties (villas/apartments/hotels) , facilitating property managers and/or owners (the &quot;Users&quot;,
    individually &quot;User&quot;) to manage everything related to the their property from the booking up until
    the checkout and the invoicing (the &quot;Service&quot;).
    Hotel Point is committed to the protection of your personal data. Therefore, we take the necessary
    and proportionate measures to protect, secure and maintain the integrity and availability of your
    data processed via the Platform Hotel Point ( “Platform”).
    Users (in this case, hotel clients) are encouraged to read this Privacy Policy carefully. By using the
    Platform, you have read and understood the terms of this privacy policy. Using the Platform after
    modifications to this Privacy Policy constitutes your understanding of those changes.
    The Privacy Policy is directly linked to and accompanies the Terms of Use of the Platform. Please
    refer to them for more information.
    `,
  dataProcessorController: `
    The Company under the name “MYKONIAN REVENUE MANAGEMENT P.C.” (the “Company”) ,with
    corporate seat in Athens, Greece, is the administrator of the platform HotelPoint, which acts as Data
    Processor for the personal data the Hotels (Data Controllers) process via its platform.
    The Company acts as Data Controller only in cases the Users contact the Platform directly for any
    reason.
    You may contact MYKONIAN REVENUE MANAGEMENT P.C for any request regarding your data by
    sending an email (info@mykonianrevenue.com), although we encourage you to contact first your
    Hotel (Data Controller).
    `,
  dataYouMayShare: {
    title: "Data the Hotel may share with us",
    content:
      "The Platform is a tool that facilitates the management of your property and your reservations. Thus,we may process a number of data regarding your trip at your property of choice as shown below:",
    table: {
      headers: ["Data Category", "Data Fields"],
      rows: [
        {
          category: "Identification Data",
          fields: "First Name, Last Name",
        },
        {
          category: "Communication Data",
          fields: "Email, Phone, Address, Country",
        },
        {
          category: "Other Information regarding the stay",
          fields:
            "Check-in/Check-out dates, Number of adults/kids, Room type/number, Booking source, Any Personal Message shared, Payment Information (Total amount, Payment method)",
        },
        {
          category: "Payment Information",
          fields:
            "Total amount, Payment method, *We do not process debit/credit card data and do not keep any personal payment details",
        },
      ],
    },
    content_end: `The above-mentioned data is provided to us via Channex, which is used as a data processor for your
    Hotel of choice.`,
  },
  dataWeCollect: {
    title: "Data We Collect from You",
    content:
      "To participate in the Platform you shall create a User profile. You may also need to contact the Platform for any reason. In such cases Users may accordingly be requested to provide:",
    table: {
      headers: ["Data Category", "Data Fields"],
      rows: [
        {
          category: "Identification Data",
          fields: "First Name, Last Name",
        },
        {
          category: "Communication Data",
          fields: "Email, Mobile, Address",
        },
        {
          category: "Other Personal Information",
          fields: "Password, Position details, Property Role",
        },
      ],
    },
  },
  purposeLawfulBasis: [
    {
      startContent: `The processing of personal data of users is subject to the terms hereof, the relevant provisions of the
      General Data Protection Regulation (EU / 2016/679), the Greek law 4624/2019 and Greek Law
      3471/2006 on the protection of personal data in electronic communications.
      We act as Data Processors and use data we collect through our Platform under the guidance of the
      Data Controller for the following purposes and based on the following lawful bases:`,
      purpose: `To offer our Service and enable the User to manage its property properly through
        the Platform`,
      lawfulBasis: "Performance of a contract",
      endContent: "",
    },
    {
      startContent: `We act as Data Controllers for the following purposes and on the following lawful bases:`,
      purpose: "Communication with users upon request",
      lawfulBasis: "Legitimate interest of the company to answer to messages and resolve issues",
      endContent: `We may also process and forward user personal data to comply with our legal obligations or orders
      from the relevant police, public and judicial authorities.`,
    },
  ],
  dataRetention: `
  We retain the data on our Platform, on our Clients’ (Hotels) guidance and only the User (Hotel) as
  Data Controller can manage the dedicated page of its property to delete data entries.
  In case a User (Hotel) stops its subscription, we retain its data up to 3 months and then we delete it,
  unless it asks us specifically to do so earlier.
    `,
  recipientsOfData: `
  Your data may need to become available to Hotel Point’s personnel, and website maintenance
  technicians. All parties are bound by the obligation of confidentiality and due process.
  Our Platform is hosted by Digital Ocean in its servers in Germany and our email providers is Smp2go
  (Sand Dune Mail Ltd) with servers in the EU. The above-mentioned parties operates as operates as
  data processors for us and are bound by the obligation of compliance with the rules of
  confidentiality and lawful processing as provided in the relevant data protection legislation. Other
  than that we do not transfer data to any third-party.
  Please note that your personal data may be disclosed (i) to partners of the consortium for
  operational reasons based on our legitimate interest on a strict need to know basis, or (ii) in any case
  where we are required to do so under applicable law or when necessary for the purposes of our
  legal interests’ protection, always ensuring that the guarantees for its safety and protection is met.
  Exceptions to the above, are cases in which forwarding to third parties or not deleting the emails we
  receive, is necessary to comply with our obligations arising from the law or to establish, exercise or
  support legal claims.
    `,
  technicalMeasures: `
  We work with the Platform &#39;s hosting service provider, to ensure that your personal data is
  protected, maintaining the data of our website within the European Economic Area. Data is
  protected by European legislation.
  Our Platform uses an encryption system (SSL) to ensure greater security during your navigation.
  We also store encrypted backups of our database to a third-party storage provider (Acronis) in the
  EU to ensure its security in the event of an emergency or disaster.
  We might from time-to-time use third party vendors and hosting partners to provide the necessary
  hardware, software, storage and related technology required for the operation of the Platform.
    `,
  contact: `
  The communication with our Platform is available via email at info@mykonianrevenue.com.
  Only our authorized personnel, who is bound by confidentiality clauses or by a regulatory obligation
  of confidentiality, have access to the messages we receive on our platform.
  We do not forward messages to third parties which we receive on our platform without the explicit
  consent of the sender.
    `,
  socialMedia: `
  HotelPoint uses social media to promote its Services. This policy does not apply when you use social
  media to get in touch with our Platform. Instead, the processing of your personal data is subject to
  the privacy policy of such social media. We advise you to read the social media privacy policy
  carefully before using them.
    `,
  yourRights: [
    {
      name: "Right to Information",
      detail:
        "You have the right to be informed about the collection and processing of your personal data.",
    },
    {
      name: "Right to Access",
      detail: `You have the right to receive confirmation from us as to whether or not
        your personal data is being processed and, if so, you have the right to
        access your personal data in a concise, comprehensible, transparent
        and easily accessible form.`,
    },
    {
      name: "Right to Correction",
      detail: `You can request and we will ensure that without undue delay we will
        correct inaccurate or incomplete personal data, including via a
        supplementary statement.`,
    },
    {
      name: "Right to Erasure",
      detail: `You have the right to ask us to delete the personal data that concern
        you, without undue delay and we will proceed with the deletion, under
        the conditions set by the law.`,
    },
    {
      name: "Right to Processing Limitation",
      detail: `You have the right to ask us to limit processing activities to specific
        purposes only, subject to the conditions set by the law.`,
    },
    {
      name: "Right to Object",
      detail: `You have the right to object, at any time and for reasons related to
        your particular situation, to the processing of personal data concerning
        you. We will no longer process personal data unless there are
        compelling and legitimate reasons for processing that override your
        interests, rights and freedoms or to establish, exercise or uphold legal
        claims.`,
    },
    {
      name: "Right to Data Portability",
      detail: `You have the right to receive the personal data concerning you, which
        you have provided us with, in a structured, commonly used and
        machine-readable format, as well as the right to request the transfer of
        such data to another processor without objection from us under the
        conditions set by the law.`,
    },
    {
      name: "Right to Human Interference",
      detail: `You have the right to not be subject to a decision made solely on the
        basis of automated processing, including profiling, which produces
        legal effects that concern you or significantly affect you in a similar
        way.`,
    },
  ],
  contactDetails: `If you have any questions about this privacy notice or would like to ask for clarification or if you wish
    to exercise any of your rights or withdraw your consent to any communication, please contact
    info@mykonianrevenue.com.
    We will respond to your request within thirty (30) days of receipt. In the event that an extension of
    the above deadline is required for the investigation and / or processing of your request, we will
    inform you, explaining the reasons why the extension of the deadline is necessary.
    In any case, if you feel that the protection of your personal data has been violated in any way, you
    have the right to file a complaint to the Hellenic Personal Data Protection Authority (www.dpa.gr).
    For the Authority’s jurisdiction and the way of submitting a complaint, you can visit its website
    where there is detailed information.`,
  modificationPolicy: `
  We may make changes to this Policy from time to time. We may make these modifications for a
  variety of reasons, for example to reflect changes or requirements arising from the law, new
  features or changes in corporate practices. The latest version will be published in the relevant place
  on the Platform. You should check often to find the latest version. The latest version is the applicable
  one. If the changes involve significant ones that affect your rights or obligations, we will notify you in
  advance via reasonable means, which may include notice through the Platform or by email. If you
  continue to use the Services after the changes take effect, you agree to the revised notice.
    `,
};

export default privacyPolicyData;
